import styled from 'styled-components';

export const StyledSection = styled.section`
	display: flex;
	flex-direction: column;
	gap: 12px;
	width: 100%;

	max-width: 1248px;
`;
